import { config } from "../../../config";
import { SupabaseService } from "../../../server/supabase/base-supabase-service";

import type { Database } from "../../../__definitions__/database-definitions";
import type { UUID } from "../../../utils/uuid";
import type { ChannelName } from "../../channels/types";
import type { PostgrestResponse } from "@supabase/postgrest-js";

export type RecipientPerson = Database["public"]["Tables"]["recipient"]["Row"];

export type RecipientPersonGroup = RecipientPerson & { group: string | null };
export class SupabaseRecipientService extends SupabaseService<"recipient"> {
  table = "recipient" as const;

  async getForChannel(
    account_id: UUID,
    channel: Exclude<ChannelName, null>,
    target_channel?: boolean,
    ids?: UUID[],
  ): Promise<PostgrestResponse<RecipientPersonGroup>> {
    const channelId = config.channel[channel];
    let query = this.client
      .from("recipients")
      .select("*", { count: "exact" })
      .eq("channel_id", channelId);

    if (target_channel !== undefined) query = query.eq("is_multiperson", target_channel);

    if (ids) query = query.in("id", ids);

    return (await this.getAllFromSelection(account_id, query, {
      order: [{ column: "group" }, { column: "display" }],
      // oxlint-disable-next-line typescript/no-unsafe-type-assertion
    })) as PostgrestResponse<RecipientPersonGroup>;
  }
}
